module.exports = __webpack_public_path__ + "img/img4.96050d50.png";